"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("span", {
  className: "text-danger"
}, "Invalid Email.");
var _ref2 = /*#__PURE__*/_react.default.createElement("span", null, "Loading...");
var _ref3 = /*#__PURE__*/_react.default.createElement("span", {
  className: "text-danger"
}, "This user does not exist.");
var _ref4 = /*#__PURE__*/_react.default.createElement("span", {
  className: "text-danger"
}, "User is blocked.");
var _ref5 = /*#__PURE__*/_react.default.createElement("span", null, "User has never logged in.");
class ExistingUserCheck extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_displayDateTime", value => {
      if (!value) return '';
      const datePart = value.split('T')[0];
      const timePart = value.split('T')[1].split('.')[0];
      return (0, _occasion.default)(datePart, 'D MMM') + ' ' + timePart.substring(0, 5);
    });
  }
  render() {
    if (!this.props.userEmail) return null;
    if (!/^.+\@.+\.[^.]+$/.test(this.props.userEmail)) return _ref;
    if (!this.props.loaded) return _ref2;
    if (!this.props.userByEmail) return _ref3;
    if (this.props.userByEmail.isBlocked) return _ref4;
    if (this.props.userByEmail.lastLogin) return /*#__PURE__*/_react.default.createElement("span", {
      className: "text-success"
    }, "Last logged in on ", this._displayDateTime(this.props.userByEmail.lastLogin));
    return _ref5;
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref6 = {
  id: true,
  lastLogin: true,
  isBlocked: true
};
var _default = exports.default = (0, _reactBicycle.connect)(ExistingUserCheck, props => {
  if (props.userEmail) {
    return {
      ["userByEmail(email:" + JSON.stringify(props.userEmail) + ")"]: _ref6
    };
  }
}, undefined, {
  renderLoading: true
});